export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "auth.worker.b3e2400f65128e358ddf.worker.js");
}
